import { useSelector } from 'react-redux';

import { cx } from '@travel/utils';

import { getDetailSummary, getIsDirectContractType } from 'store/providerInformation/selectors';

import JapanQualityAndAward from '../JapanQualityAndAward';

import styles from './overview.module.scss';

type Props = {
  /** String defining current provider id */
  pageIdentifier: string;
  /** parent page name for RAT popups */
  pageName: string;
};

function OverviewAwardsAndCatchphrase(props: Props) {
  const { pageIdentifier, pageName } = props;

  const detailSummary = useSelector(getDetailSummary(pageIdentifier));
  const isDirectContractType = useSelector(getIsDirectContractType);

  const { catchCopy } = detailSummary;

  return (
    <div
      className={cx(styles.overviewAwardsAndCatchphrase, styles.overviewInfoContainer)}
      data-testid="overview-awardsAndCatchphrase"
    >
      {isDirectContractType && (
        <JapanQualityAndAward pageName={pageName} pageIdentifier={pageIdentifier} />
      )}

      {/* catchphrase */}
      {catchCopy && (
        <p className={styles.catchCopy} data-testid="providerInformation-overview-catchCopy">
          {catchCopy}
        </p>
      )}
    </div>
  );
}

export default OverviewAwardsAndCatchphrase;
